import { CollapsibleCard, type ToolRendererProps } from '../ToolCard';

interface CodeResult {
  stdout?: string;
  stderr?: string;
  output?: string;
  return_code?: number;
  exit_code?: number;
  result?: string;
}

export function CodeResultCard({ toolName, result }: ToolRendererProps) {
  const r =
    result && typeof result === 'object' && !Array.isArray(result)
      ? (result as CodeResult)
      : { output: String(result) };

  const stdout = r.stdout ?? r.output ?? r.result ?? '';
  const stderr = r.stderr ?? '';
  const exit = r.return_code ?? r.exit_code;

  return (
    <CollapsibleCard toolName={toolName} defaultOpen>
      {exit !== undefined && (
        <div className="mb-1 text-[10px] text-bark">
          exit: <span className={exit === 0 ? 'text-moss' : 'text-red-600'}>{exit}</span>
        </div>
      )}
      {stdout && (
        <pre className="max-h-64 overflow-auto rounded bg-fog/40 p-2 font-mono text-[11px] leading-relaxed text-espresso whitespace-pre-wrap">
          {stdout}
        </pre>
      )}
      {stderr && (
        <>
          <div className="mt-1.5 text-[10px] uppercase tracking-wide text-red-600">stderr</div>
          <pre className="max-h-40 overflow-auto rounded bg-red-50 p-2 font-mono text-[11px] leading-relaxed text-red-700 whitespace-pre-wrap">
            {stderr}
          </pre>
        </>
      )}
      {!stdout && !stderr && (
        <pre className="text-[11px] text-espresso">{JSON.stringify(result).slice(0, 300)}</pre>
      )}
    </CollapsibleCard>
  );
}
